import values from 'lodash-es/values';
import * as EventListeners from './ActionListeners/EventSuccessListeners';
import * as offerCodeListeners from './ActionListeners/offerCodeListeners';
import * as planListeners from './ActionListeners/planListeners';

const listeners = [...values(EventListeners), ...values(offerCodeListeners), ...values(planListeners)];

export default listeners;
